/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { getAuthToken } from '@/utils/auth.utils'
import HttpRequest from './http-request'

export default class WebCampaignTagProvider extends HttpRequest {
  getWebCampaignTags (query?: any): Promise<any> {
    this.setHeader(getAuthToken())
    return this.get('/web-campaign-tags', query)
  }
}
